import i18n from 'i18next'
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from 'react-i18next'
import XHR from 'i18next-xhr-backend'
import languageEN from './locate/en/en.json'
import languageFR from './locate/fr/fr.json'
import languageGE from './locate/ge/ge.json'
import languageIN from './locate/in/in.json'
import languageSP from './locate/sp/sp.json'

i18n
    .use(XHR)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: languageEN,
            fr: languageFR,
            ge: languageGE,
            in: languageIN,
            sp: languageSP,
        },
        /* default language when load the website in browser */
        lng: localStorage.getItem("i18nextLng") ?? 'en',
        /* When react i18next not finding any language to as default in borwser */
        fallbackLng: "en",
        /* debugger For Development environment */
        debug: false,
        ns: ["translations"],
        defaultNS: "translations",
        keySeparator: ".",
        interpolation: {
            escapeValue: false,
            formatSeparator: ","
        },
        react: {
            wait: true,
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default',
            useSuspense: true,
        }
    })

export default i18n;